import { ComponentOptionsMixin } from 'vue/types/v3-component-options';

const mixins: ComponentOptionsMixin = {
  methods: {
    /**Checks if current component has slot supplied */
    $hasSlot(name = 'default'): boolean {
      return !!this.$slots[name] || !!this.$scopedSlots[name];
    },

    /**Coalesce function. For safe access to nested objects in case of null.
     * @param obj initial object
     * @param property dot separated property path
     * @param $return return value if access failed, null by default
     * @example: $cc(obj, 'prop1.prop2');
     */
    $cc(obj: any, property: string, $return = null) {
      if (!obj) {
        return $return;
      }

      const properties = property.split('.');
      if (!properties.length) return $return;

      let res = obj;

      while (properties.length && (res = res[properties.shift() ?? '']));
      return res || $return;
    },
  },
};

export default mixins;
